import React from 'react';
const points = [{
  icon: '🔧',
  title: 'Practical maintenance resources',
  text: 'Find the right checklist, workflow or maintenance tool when you need it.'
}, {
  icon: '📋',
  title: 'Structured maintenance processes',
  text: 'Move from inspection or maintenance request to action with a clearer process.'
}, {
  icon: '🏭',
  title: '6 maintenance areas',
  text: 'Prevention, inspections, troubleshooting, work orders, records and control.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  text: 'Return to the tools whenever a new maintenance task appears.'
}];
export function ChangeSection() {
  return <section className="border-y border-brand-line bg-white px-4 py-4" data-id="element-28" data-mp="2ytcj3ogd5dw">
      <div className="mx-auto max-w-3xl text-center" data-id="element-29" data-mp="7w2zmcodd4yk">
        <h2 className="font-display text-[19px] leading-tight sm:text-2xl" data-id="element-30" data-mp="7yp6ea3frgfq">
          This isn&apos;t just another maintenance ebook
        </h2>
        <p className="mb-2.5 font-cond text-[15px] font-bold uppercase tracking-wide text-brand-carbon sm:text-xl" data-id="element-31" data-mp="22avto79ltnoe">
          It&apos;s a <span className="bg-brand-yellow px-1" data-id="element-32" data-mp="3dbkw66o8iv41">ready-to-use maintenance system</span>.
        </p>
        <ul className="grid gap-2 text-left sm:grid-cols-2" data-id="element-33" data-mp="39b0zt5bhjviy">
          {points.map(point => <li key={point.title} className="flex h-full gap-2 rounded-lg border border-brand-line bg-brand-paper p-3" data-id="element-34" data-mp="3n1w1nxnkhcd1">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-35" data-mp="3i4e04sbvpzf2">
                {point.icon}
              </span>
              <div data-id="element-36" data-mp="2ug36a94lp00a">
                <p className="font-cond text-[13px] font-bold uppercase leading-tight text-brand-carbon sm:text-base" data-id="element-37" data-mp="2qcy3s6kisybn">
                  {point.title}
                </p>
                <p className="text-[12px] font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-38" data-mp="34acztu5a44cl">
                  {point.text}
                </p>
              </div>
            </li>)}
        </ul>
        <p className="mt-2 font-cond text-[13px] font-bold uppercase tracking-wide text-brand-carbon sm:text-base" data-id="element-39" data-mp="jobfojlrbb07">
          Less searching. Less improvising. More control.
        </p>
      </div>
    </section>;
}